import React, { memo } from 'react';
import './Loading.css';
import { useGlowEffect } from '../../Utils/glowEffect';

const Loading = memo(({ message = 'Loading your experience', hint = '' }) => {
    useGlowEffect();

    return (
        <div id="loading-container" role="status" aria-live="polite" aria-busy="true">
            <div id="loading-spinner"></div>
            <div id="loading-text" className="gradient-text">{message}</div>
            {hint ? <div id="loading-hint">{hint}</div> : null}
        </div>
    );
});

export default Loading;